import {isDate} from 'lodash'
import {isSameDay, isBefore, format} from 'date-fns'
import {parseNumber} from './numberParser.service'

const formatCurrency = (amount: number | undefined, decimals = 2, postfix = ''): string => {

    if (amount === undefined) {
        return ''
    }

    const formatted = new Intl.NumberFormat('no', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals
    }).format(parseNumber(amount))
    if (postfix) {
        return `${formatted} ${postfix}`
    }
    return formatted
}

const formatPercentage = (fraction: number, decimals = 2, postfix = '%', minimumFractionDigits = 0) => {
    const formatted = new Intl.NumberFormat('no', {
        minimumFractionDigits,
        maximumFractionDigits: decimals
    }).format(fraction * 100)
    return formatted + postfix
}

const formatDateTimeCompact = (date: string | Date | undefined): string => formattedDate(date, 'dd.MM.yy HH:mm')

const formatDateTime = (date: string | Date | undefined): string => formattedDate(date, 'dd.MM.yyyy HH:mm:ss')

const formattedDate = (date: string | Date | undefined, dateFormat = 'dd.MM.yyyy') => {
    if (!date) return ''
    if (isDate(date)) return format(date, dateFormat)
    return format(new Date(date), dateFormat)
}

const isDateBeforeOrEqual = (date1: Date, date2: Date) => isBefore(date1, date2) || isSameDay(date1, date2)

const compactNumber = (value: number, decimal: number = 0) => {
    if (value === undefined)
        return ''
    let valueToShow = value
    let postfix = ''


    if (Math.abs(value) > 10_000) {
        valueToShow = value / 1000
        postfix = 'K'
    }

    if (Math.abs(value) > 10_000_000) {
        valueToShow = value / 1_000_000
        postfix = 'M'
    }
    return formatCurrency(valueToShow, decimal, postfix)
}

export {
    formatDateTime,
    isDateBeforeOrEqual,
    formatCurrency,
    formatPercentage,
    formattedDate,
    compactNumber,
    formatDateTimeCompact
}